<template>
  <div v-loading='loading' id='ciframe' >
     <iframe  id='myiframe' :src='gurl'></iframe>
  </div>
  <!-- http://localhost:8383/#/payment@url=http://172.16.36.11/tran -->
</template>



<style>
  #ciframe {
    position: absolute;
    /* width:80%; */
    left:calc(16.5% + 24px);
    right:24px;
    height: calc(100% - 104px);
    background:none;
  }

  #ciframe iframe {
    width:100%;
    height:100%;
  }
</style>

<script>
  import $ from 'jquery'
  export default{
    data () {
      return {
        loading: true,
      }
    },
    props: [
    ],
    watch: {

    },
    computed: {
      gurl () {
        return this.$store.getters.gIfurl
      },
    },
    methods: {

    },
    mounted () {
      var _this = this
      $(document).ready(function(e){  
    　　 var iframe = document.getElementById("myiframe");    
        if (iframe.attachEvent) {    
            iframe.attachEvent("onload", function() {    
                //iframe加载完成后你需要进行的操作  
                _this.loading = false
            }) 
        } else {    
            iframe.onload = function() {    
              //iframe加载完成后你需要进行的操作  
              _this.loading = false
            }
        }    
      })
      
    },
    destroyed () {
      
    }
  }
</script>



// WEBPACK FOOTER //
// ciframe.vue?19f91828